import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/thi-beacon-frontend/thi-beacon-frontend/src/components/Events/PublicEventsLayout.tsx");
